module.exports = __webpack_public_path__ + "static/logo-1c5b499157a7931b2d1590cfa326a70b.png";